/**
 * simple store
 */

export default {
  state: {
    currentMusicName: "",
    currentProjectName: "",
    currentMusic: null,
    currentProject: null,
  },
  setMusicAction (newMusicSrc, newMusicName) {
    this.state.currentMusic = newMusicSrc;
    this.state.currentMusicName = newMusicName;
  },
  setProjectAction (newFileObj, projectName) {
    this.state.currentProject = newFileObj;
    this.state.currentProjectName = projectName;
  }
}


// WEBPACK FOOTER //
// ./src/Store.js